import styled from 'styled-components';
import { getSemanticValue } from '@freenow/wave';

export const GreyRelativeWrapper = styled.div`
    margin: 0;
    border: 0;
    box-sizing: border-box;
    background-color: ${getSemanticValue('background-page-elevation-0')};

    position: relative;
    font-weight: 400;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    min-height: 100vh;
    height: 100%;
    display: flex;
    flex-direction: column;
`;
